import React, { useState, useEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import i18next from 'i18next';
import Row from 'react-bootstrap/Row';

import Background from '../../resources/assets/hero-home-oct-2020.jpeg';
import CheckMark from '../../lib/CheckMark';
import InputBox from '../../lib/InputBox';
import Overlay from '../../lib/Overlay';
import { isValidPassword, isLongEnough, hasNumber, hasLetters, PASSWORD_MAX_LENGTH } from '../../lib/password';
import { redirect } from '../../lib/environment';

export default function ResetPasswordView(props) {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const autoFocus = useRef(null);

  useEffect(() => autoFocus.current.focus(), []);

  return (<>
    <Container style={{
      minHeight: '611px',
      backgroundImage: `url(${Background})`,
      borderRadius: '3px' ,
      boxShadow: "0 0 8px 8px rgba(40, 44, 52, 0.7) inset"
      }}>
      <Row>
        <Col md={{ span: 7, offset: 1 }}>
          <InputBox style={{ height: '534px', width: '621px' }}>
            {props.state === 'success' ? renderSuccess() : renderForm()}
          </InputBox>
        </Col>
      </Row>
    </Container>
  </>);

  function renderForm() {
    return (<>
      {props.state === 'waiting' && <Overlay />}
      <Container style={{ marginLeft: '1em', marginRight: '1em' }}>
        <Row style={{ marginBottom: '10px' }}>{i18next.t('reset.title')}</Row>
        {displayRow(i18next.t('reset.minlength'), isLongEnough(password))}
        {displayRow(i18next.t('reset.case'), hasLetters(password))}
        {displayRow(i18next.t('reset.number'), hasNumber(password))}
      </Container>
      <Form style={{ width: '100%', margin: '1em' }} onSubmit={event => {event.preventDefault(); props.onSubmit(password)}}>
        <Form.Group controlId="password">
          <Form.Label>{i18next.t('reset.password')}</Form.Label>
          <Form.Control name="password" type="password" placeholder={i18next.t('reset.password')} value={password} maxLength={PASSWORD_MAX_LENGTH} onChange={event => setPassword(event.target.value)} ref={autoFocus} />
        </Form.Group>
        <Form.Group controlId="confirm">
          <Form.Label>{i18next.t('reset.confirmPassword')}</Form.Label>
          <Form.Control name="confirmPassword" type="password" placeholder={i18next.t('reset.confirmPassword')} value={confirmPassword} maxLength={PASSWORD_MAX_LENGTH} onChange={event => setConfirmPassword(event.target.value)} />
        </Form.Group>
        <Button name="submit-request" variant="primary" type="button" disabled={isDisabled()} onClick={() => props.onSubmit(password)}>
          {i18next.t('reset.resetPassword')}
        </Button>
        <p id="message" style={{ marginTop: '0.5em' }}>{props.message}</p>
        {!isDisabled() && <input type='submit' hidden tabIndex='-1' />}
      </Form>
    </>);
  }

  function displayRow(label, passedCheck) {
    const colour = passedCheck ? 'rgba(181, 190, 92, 1)' : 'rgba(194, 158, 107, 0.6)';
    return <Row className="align-self-center"><CheckMark colour={colour} /> {label}</Row>
  }

  function isDisabled() {
    return !(isValidPassword(password) && password === confirmPassword);
  }

  function renderSuccess() {
    return (<>
        <p id="message" style={{ margin: '1em' }}>{props.message}</p>
        <Button name="submit-redirect" variant="primary" type="button" disabled={isDisabled()} onClick={() => redirect()}>
          {i18next.t('reset.returnApplication')}
        </Button>
    </>);
  }
}
